import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import OpenAIMasthead from "@/components/OpenAIMasthead";
import { EditorialMarquee, Manifesto, Services, Process, CaseStudies, Testimonials } from "@/components/Sections";
import AmazonSection from "@/components/AmazonSection";
import AboutSection from "@/components/AboutSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import MobileCTABar from "@/components/MobileCTABar";

export default function Landing() {
  return (
    <main className="relative bg-[#FDFCF8]">
      <Navbar />
      <OpenAIMasthead />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <AmazonSection />
      <Process />
      <CaseStudies />
      <AboutSection />
      <Testimonials />
      <FinalCTA />
      <Footer />
      <WhatsAppButton />
      <MobileCTABar />
    </main>
  );
}
